import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step2Schema = z.object({
  collectiveFinancingResults: z.object({
    value: z.enum([
      'investmentAppreciated',
      'investedMoreThanEarned',
      'noResultsYet',
      'noExperience',
    ]),
    score: z.number(),
  }),
})

export type Step2Data = z.infer<typeof step2Schema>

export function Step2() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step2Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.collectiveFinancingResults.question.label}
          </StepTitle>
          <Controller
            control={control}
            name="collectiveFinancingResults"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.collectiveFinancingResults.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
